<router-outlet></router-outlet>
<iot-platform-notification></iot-platform-notification>
